











import { defineComponent} from '@vue/composition-api'
import { useActions, useGetters } from 'vuex-composition-helpers'

import SelectAtom from '@/shared/components/atoms/SelectAtom.vue'

export default defineComponent({
    name: "FormSelectComponent",
    components: {
        SelectAtom
    },
    props: {
        category: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        }
    },
    setup: () => {
        const { options, selectedOption } = useGetters('impersonation', [ 'options', 'selectedOption'])
        const { changeSelection } = useActions('impersonation', ['changeSelection'])

        return {
            options,
            selectedOption,
            changeSelection
        }
    }
})
